import React from "react";
import { cn } from "@/utils/helpers";
import SvgIcon, { SvgIconProps } from "./SvgIcon";
import styles from "../Svg.module.css";

export default function SvgIconDownload({
	className,
	...props
} : SvgIconProps) {
	return (
		<SvgIcon
			className={cn(styles.SvgIconDownload, className)}
			{...props}
		>
			<path d="M92.3921 3.31213C98.1705 1.41537 102.574 8.60692 98.2747 12.9196L54.0857 57.2484C51.8292 59.512 48.1708 59.512 45.9143 57.2484L1.72529 12.9196C-2.57382 8.60691 1.8295 1.41537 7.60788 3.31212L48.2031 16.6375C49.3706 17.0207 50.6294 17.0207 51.7969 16.6375L92.3921 3.31213Z" />
			<path d="M96.4485 86.4074V98L4 98L4 86.4074L96.4485 86.4074Z" />
		</SvgIcon>
	)
}
